export const PRIVATE_GIFT_GIVER_CATEGORY_ID = 3
